// src/account.js
// Deleting an account for good: what the server has, what this device has, and then the sign-in itself.
import { confirmItIsYou, removeSignIn } from './auth';
import { auth } from './firebase';
import { forgetGuest, guestId } from './guest';
import { localClient, serverClient } from './sync/sync';

const forgetOnDevice = async (uid) => {
    try {
        await localClient(uid)('POST', '/localSync/forget');
    } catch (error) {
        // the device's copy could not be removed (the engine is not running): it is only a copy
    }
    try {
        window.localStorage.removeItem(`tournamental.collab.${uid}`);
    } catch (error) {
        // nothing stored
    }
};

// The order matters: first prove it is them (it can fail, and nothing is gone yet), then the server's data (safe to
// repeat if the last step fails), then this device's copy, then the sign-in.
export async function deleteAccount({ password } = {}) {
    const uid = auth.currentUser.uid;
    await confirmItIsYou(password);
    await serverClient(uid)('DELETE', '/account');
    await forgetOnDevice(uid);
    await removeSignIn();
}

// A guest's tournaments only exist on the device.
export async function deleteGuestData() {
    const uid = guestId();
    if (uid) await forgetOnDevice(uid);
    forgetGuest();
}
